import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { CHART_COLORS, getTheme } from './chartTheme'
import ChartTooltip from './ChartTooltip'

const ExpenseTrendChart = ({ data = [], height = 300, isDark = false }) => {
  const { t } = useTranslation('common')
  const theme = getTheme(isDark)

  const chartData = data.map((item) => ({
    name: item.month || item.label,
    wydatki: parseFloat(item.total || item.amount || 0),
  }))

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height, color: 'var(--color-text-faint)' }}>
        {t('noData')}
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="expenseGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={CHART_COLORS.primary} stopOpacity={0.3} />
            <stop offset="100%" stopColor={CHART_COLORS.primary} stopOpacity={0.0} />
          </linearGradient>
        </defs>
        <CartesianGrid
          strokeDasharray="3 3"
          stroke={theme.grid}
          vertical={false}
        />
        <XAxis
          dataKey="name"
          axisLine={false}
          tickLine={false}
          tick={{ fill: theme.textSecondary, fontSize: 12 }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fill: theme.textSecondary, fontSize: 12 }}
          tickFormatter={(val) => `${val} ${t('currency')}`}
          width={70}
        />
        <Tooltip
          content={<ChartTooltip />}
        />
        <Area
          type="monotone"
          dataKey="wydatki"
          stroke={CHART_COLORS.primary}
          strokeWidth={2.5}
          fill="url(#expenseGradient)"
          dot={false}
          activeDot={{ r: 5, fill: CHART_COLORS.primary, stroke: theme.dotStroke, strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ExpenseTrendChart
